// removed by extract-text-webpack-plugin
module.exports = {"frontBack":"_3VLc_8CC3eoAHbokTvLsaK","separator":"_2BMVdO53BgJIgCH6VsvZNr","front":"XiW6IMj5sLXgPYaKamtXW","back":"_2aJqqzmjltbsi19aOmWq0t","active":"_3aJXdqX9kfeX0-V9HqIbJW"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/FrontBack.styl
// module id = 587
// module chunks = 0